import { render, staticRenderFns } from "./Lgx184752426752933888.vue?vue&type=template&id=ad7980cc&"
import script from "./Lgx184752426752933888.vue?vue&type=script&lang=js&"
export * from "./Lgx184752426752933888.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports